<sc-action-icon (click)="clickButton()" [disabled]="disabled"
  title="{{'attach / detach' | translate:['tmc-yard.ui.control.sac-client.station-transport-details.action.attach-detach', translationService.language, translationService.revision]}}"
  iconClass="fa-code-merge">
</sc-action-icon>
